import { reactive, ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import * as apiQA from '@/api/qa'
import * as apiCommon from '@/api/common'
import * as common from '@/util/common'

/**
 * 書式ダウンロードウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        group1.loadData()
      }
    }),

    message: '',
    messageDisp: computed(() => {
      let value = group1.message
      value = value.replace(/<br>/g, '\n')
      value = value.replace(/<br\/>/g, '\n')
      value = value.replace(/<br.*?>/g, '\n')
      value = common.escapeHTML(value)
      return value.replace(/\r?\n/g, '<br>')
    }),

    // 書式一覧
    list: [],

    // データロード完了フラグ
    isListFormDownloadsLoaded: false,

    /**
     * 表示用データをロードする
     */
    loadData: () => {

      // 書式DL一覧APIをコール
      const params = {}
      params.qa_id = store.state.qa.qaId
      params.search_index_id = store.state.qa.searchIndexId

      apiQA.listFormDownloads(params)
        .then(response => {
          if (response) {
            const { data } = response

            group1.isListFormDownloadsLoaded = true

            group1.message = data.message ?? ''
            const listWork = data.list

            for (let i = 0; i < listWork.length; i++) {
              const fileId = listWork[i].file_id
              // 書式のURL
              listWork[i].url = apiCommon.getFetchFileAPIURL(fileId, true)

            }
            group1.list = listWork

          }
        })
    }

  })

  return group1
}
